import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconImageStackPlus20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconImageStackPlus20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13.5 9.888A4.5 4.5 0 0 1 10.468 7.5H3.5a1 1 0 0 0-1 1v4.721l2.564-1.831.517-.37.45.45 5 5 .028.03H12.5a1 1 0 0 0 1-1zM10.028 6a4.5 4.5 0 0 1 .083-1.5H6.5a1 1 0 0 0-1 1V6zm.73-3A4.5 4.5 0 1 1 18 8.329V12.5a2.5 2.5 0 0 1-2.5 2.5H15v.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 15.5v-7A2.5 2.5 0 0 1 3.5 6H4v-.5A2.5 2.5 0 0 1 6.5 3zM16.5 9.532a4.5 4.5 0 0 1-1.5.44V13.5h.5a1 1 0 0 0 1-1zM14.5 3a.75.75 0 0 0-.75.75v1h-1a.75.75 0 0 0 0 1.5h1v1a.75.75 0 1 0 1.5 0v-1h1a.75.75 0 0 0 0-1.5h-1v-1A.75.75 0 0 0 14.5 3m-12 12.065v.435a1 1 0 0 0 1 1h5.44l-3.521-3.52zm8.25-2.565a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 1.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconImageStackPlus20);
